export default __webpack_public_path__ + "static/media/image-03.461ff421.jpg";